export default "__VITE_ASSET__BHXfk43X__"